import { useTranslations } from 'next-intl'

import { useFormatDate } from '@/shared/lib'

type Props = {
  week: number
  startDate: string
  endDate: string
  isExtend?: boolean
}

export const Period = ({
  week,
  startDate: startDateProp,
  endDate: endDateProp,
  isExtend = false,
}: Props) => {
  const t = useTranslations()
  const { formatDateWithDayOfWeek } = useFormatDate()

  const startDate = formatDateWithDayOfWeek({
    date: startDateProp,
  })
  const endDate = formatDateWithDayOfWeek({
    date: endDateProp,
  })

  return (
    <div className="flex items-center gap-2">
      {week && (
        <span className="typo-caption2 block rounded-full border border-purple-300 px-[5px] py-px font-medium text-purple-300">
          {t('common.week', { week })}
          {isExtend ? ` ${t('lease_request.extension')}` : ''}
        </span>
      )}
      <span className="typo-label2 font-normal">
        {startDate} ~ {endDate}
      </span>
    </div>
  )
}
